var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"conversation-marker",attrs:{"align-center":""}},[_c('hr'),(_vm.hasDate)?_c('span',{staticClass:"date px-4"},[_vm._v("\n    "+_vm._s(_vm.date)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }